module.exports = __webpack_public_path__ + "static/img/qingqu2.3f22e3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/qqly/qingqu2.jpg
// module id = 6d6F
// module chunks = 0